import { Injectable } from '@angular/core'
import { Observable, BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class WindowService {
  private isMobileViewSubject: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false)
  isMobileView$: Observable<boolean> = this.isMobileViewSubject.asObservable()

  constructor() {
    this.checkIfMobileView()
    // Listen for window resize events
    window.addEventListener('resize', () => this.checkIfMobileView())
  }

  /**
   * Updates the flag indicating whether the browser is in mobile view (< 767px).
   * @returns {void}
   */
  private checkIfMobileView(): void {
    const isMobileView = window.innerWidth < 767
    this.isMobileViewSubject.next(isMobileView)
  }
}
